export const handleInputChange = <T extends Record<string, unknown>>(
    value: unknown,
    name: string,
    inputData: T,
    setInputData: React.Dispatch<React.SetStateAction<T>>
): void => {
    setInputData({ ...inputData, [name]: value });
};

export const handlePhoneInputChange = <T extends Record<string, unknown>>(
    value: unknown,
    name: string,
    inputData: T,
    setInputData: React.Dispatch<React.SetStateAction<T>>
): void => {
    setInputData({ ...inputData, [name]: value });
};
